import { Effect, Reducer } from 'umi';
export const namespace = 'rangePikerLeft';
export interface RangePikerLeftModelStateType {
  rangePickerLeftData:any
}

export interface RangePikerLeftModelType {
  namespace: string;
  state: RangePikerLeftModelStateType;
  effects: {
    setRangePickerLeftData: Effect;
  };
  reducers: {
    save: Reducer<RangePikerLeftModelStateType>;
  };
}

const RangePikerLeftModel: RangePikerLeftModelType = {
  namespace: namespace,

  state: {
    rangePickerLeftData:[],
  },

  effects: {
    *setRangePickerLeftData({ payload }, { put }) {
      yield put({
        type: "save",
        payload: {
          rangePickerLeftData: payload?.data,
        }
      });
    }
  },
  reducers: {
    save(state: RangePikerLeftModelType, action: any) {
      return {
        ...state,
        ...action.payload,
      };
    },
  }
};

export default RangePikerLeftModel;
